import ApiService from "../../Services/ApiService";

export default {
    state: {
        theme: null,
        selectedThemes: [],
        lastCheckedTheme: '0',
        checkWhenFinishedCaching: false
    },
    getters: {
        getStocksOfTheme(state) {
            return state.theme;
        },
        getSelectedThemes(state) {
            return state.selectedThemes;
        },
        getLastCheckedTheme(state) {
            return state.lastCheckedTheme;
        },
        getCheckWhenFinishedCaching(state) {
            return state.checkWhenFinishedCaching;
        }
    },
    mutations: {
        setStocksOfTheme(state, payload) {
            state.theme = payload;
        },
        setSelectedThemes(state, payload) {
            state.selectedThemes = payload;
        },
        setLastCheckedTheme(state, payload) {
            state.lastCheckedTheme = payload;
        },
        setCheckWhenFinishedCaching(state, payload) {
            state.checkWhenFinishedCaching = payload;
        }
    },
    actions: {
        async loadStocksOfTheme({ commit }, theme_id) {
            const stockIds = (await ApiService.getTheme(theme_id)).data;

            commit('setStocksOfTheme', stockIds);
        }
    },
};
